import React, {useEffect} from 'react';
import ReactMarkdown from 'react-markdown';
// @ts-ignore
import indexMd from './index.md';
interface PropsType {
}

const RenderMarkdown: React.FC<PropsType> = (props => {
  
  
    useEffect(() => {
    }, )
  
    return (
    <>
      <ReactMarkdown
          source={indexMd}
          escapeHtml={false}
      />
    </>
    )
  
})

export default RenderMarkdown;
